export * from './static-chat-messages'
